import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView05ImageOptions } from './views/InteriorView05'

class Xr41Galley extends Component {
  render () {
    let imageOptions = interiorView05ImageOptions

    let image = (
      <ConfiguratorImage
        boat='Xr41'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Galley' />
          </h1>

          <p>
            <Trans defaults='The galley is fully equipped with a coolbox, electric two-burner cooker and generous storage space for cutlery and food.' />
          </p>

          <p>
            <Trans defaults='It is also possible to add a combined oven/airfryer' />
          </p>

          <p>
            <Trans defaults='Items such as sink and hull cupboards are removable for racing.' />
          </p>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Galley)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Galley.js